// Get Reimbursements
export const GET_REIMBURSEMENTS_REQUEST = 'GET_REIMBURSEMENTS_REQUEST';
export const GET_REIMBURSEMENTS_DONE = 'GET_REIMBURSEMENTS_DONE';
export const GET_REIMBURSEMENTS_FAILED = 'GET_REIMBURSEMENTS_FAILED';
export const GET_REIMBURSEMENTS_RESET = 'GET_REIMBURSEMENTS_RESET';

// Operations
export const TOGGLE_REIMBURSEMENT = 'TOGGLE_REIMBURSEMENT';
export const TOGGLE_ALL_REIMBURSEMENTS = 'TOGGLE_ALL_REIMBURSEMENTS';
export const SET_REIMBURSEMENTS_FILTER = 'SET_REIMBURSEMENTS_FILTER';
export const SET_REIMBURSEMENTS_ALL_FILTERS = 'SET_REIMBURSEMENTS_ALL_FILTERS';
export const CLEAR_REIMBURSEMENTS_FILTERS = 'CLEAR_REIMBURSEMENTS_FILTERS';
export const REIMBURSEMENTS_SET_PAGE = 'REIMBURSEMENTS_SET_PAGE';